import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { getContainerClasses } from "../../_shared/figure/get-container-classes";
import { Giphy } from "../viewer/giphy";
const Gif = ({ settings, componentData, ...props }) => {
  const { isMobile } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: getContainerClasses(props.editor, props.node.attrs.id, isMobile),
      draggable: true,
      "data-drag-handle": true
    },
    /* @__PURE__ */ React.createElement(Giphy, { componentData, config: settings })
  );
};
export {
  Gif
};
//# sourceMappingURL=component.js.map
